<style>
/* @import 'https://unpkg.com/highcharts/css/highcharts.css'; */
input.highcharts-range-selector {
    background-color: rgb(255, 255, 255) !important;
}
.highcharts-root {
    touch-action: auto !important;
}
</style>

<template>
    <div id="container">
        <highcharts v-if="currOptions && chartData" :constructor-type="currType" class="hc" :options="currOptions" ref="highcharts"></highcharts>
    </div>
</template>

<script>
import { dataA, dataB, dataC } from "Store/modules/test_chart_data";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import bulletInit from "highcharts/modules/bullet";

stockInit(Highcharts);
bulletInit(Highcharts);

export default {
    props: ["chartType", "chartData", "height", "stockName"],
    mounted() {
        // setTimeout(() => {
        this.$nextTick(() => {
            if (this.$refs.highcharts && this.chartType && this.chartData) this.$refs.highcharts.chart.reflow();
        });
    },
    computed: {
        currOptions() {
            let options = {};
            if (this.chartType && this.chartData) {
                if (this.chartType == "stock") {
                    options = this.stockOptions;
                } else if (this.chartType == "bullet") {
                    options = this.bulletOptions;
                }
            }
            return options;
        },
        currType() {
            let type = "stockChart";
            if (this.chartType) {
                if (this.chartType == "stock") {
                    type = "stockChart";
                } else if (this.chartType == "bullet") {
                    type = "chart";
                }
            }
            return type;
        },
        bulletOptions() {
            return this.chartData && this.chartType == "bullet"
                ? {
                      chart: {
                          plotBorderColor: "#000",
                          plotBorderWidth: 1,
                          height: this.height ? this.height : "80",
                          inverted: true,
                          type: "bullet",
                          marginRight: 100,
                          backgroundColor: "transparent",
                          //   width: this.$bp.mdAndUp ? 725 : 375,
                          //   scrollablePlotArea: {
                          //       minWidth: this.$bp.mdAndUp ? 725 : 375,
                          //   },
                      },
                      title: {
                          text: null,
                      },
                      legend: {
                          enabled: false,
                      },
                      credits: {
                          enabled: false,
                      },
                      xAxis: {
                          opposite: true,
                          categories: [`<b>${Math.round(+this.chartData.user_capacity * 100) / 100}</b>`],
                          lineColor: "#000",
                          lineWidth: 1,
                      },
                      yAxis: {
                          gridLineColor: "#666",
                          max: +this.chartData.user_capacity,
                          endOnTick: false,
                          plotBands: [
                              {
                                  from: 0,
                                  to: +this.chartData.reorder_red,
                                  color: "rgba(228, 0, 1, 0.5)",
                              },
                              {
                                  from: +this.chartData.reorder_red,
                                  to: +this.chartData.reorder_yellow,
                                  color: "rgba(255, 204, 0, 0.5)",
                              },
                              {
                                  from: +this.chartData.reorder_yellow,
                                  to: +this.chartData.user_capacity,
                                  color: "#bbb",
                              },
                          ],
                          labels: {
                              format: "{value}",
                          },
                          title: null,
                      },
                      plotOptions: {
                          series: {
                              pointPadding: 0.25,
                              borderWidth: 0,
                              color: "#000",
                              targetOptions: {
                                  width: "200%",
                              },
                              dataLabels: {
                                  enabled: true,
                                  align: "right",
                                  color: "#FFFFFF",
                                  x: -10,
                                  format: "{y}",
                              },
                          },
                      },
                      series: [
                          {
                              data: [
                                  {
                                      y: +this.chartData.user_fill_volume,
                                      target: +this.chartData.user_fill_volume,
                                      pointWidth: 29,
                                  },
                              ],
                          },
                      ],
                      tooltip: {
                          pointFormat: `<b>{point.y} ${this.chartData.user_symbol}</b>`,
                      },
                  }
                : {};
        },
        stockOptions() {
            return this.chartData && this.chartType == "stock"
                ? {
                      tooltip: {
                          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                          valueDecimals: 2,
                          shared: true,
                          split: false,
                      },
                      navigator: {
                          adaptToUpdatedData: false,
                          margin: 60,
                      },
                      plotOptions: {
                          series: {
                              showInNavigator: true,
                              turboThreshold: 10000000,
                          },
                      },
                      scrollbar: {
                          liveRedraw: false,
                      },
                      series: [
                          // { name: 'MSFT', data: dataA },
                          // { name: 'AAPL', data: dataB },
                          // { name: 'GOOG', data: dataC },
                          {
                              name: this.stockName,
                              data: this.chartData ? this.chartData : [],
                          },
                      ],
                      // Enable for x-axis
                      xAxis: {
                          crosshair: true,
                      },
                      // Enable for y-axis
                      yAxis: {
                          crosshair: true,
                      },
                      rangeSelector: {
                          buttonTheme: {
                              // styles for the buttons
                              fill: "none",
                              stroke: "none",
                              "stroke-width": 0,
                              r: 8,
                              style: {
                                  color: "#039",
                                  fontWeight: "bold",
                              },
                              states: {
                                  hover: {},
                                  select: {
                                      fill: "#039",
                                      style: {
                                          color: "white",
                                      },
                                  },
                                  // disabled: { ... }
                              },
                          },
                          // inputBoxBorderColor: 'gray',
                          inputBoxWidth: 100,
                          inputBoxHeight: 18,
                          inputStyle: {
                              color: "#039",
                              fontWeight: "bold",
                          },
                          labelStyle: {
                              color: "silver",
                              fontWeight: "bold",
                          },
                          floating: true,
                          y: -65,
                          verticalAlign: "bottom",
                          enabled: true,
                          allButtonsEnabled: true,
                          inputEnabled: true,
                          buttons: [
                              {
                                  type: "week",
                                  count: 1,
                                  text: "1w",
                                  title: "View 1 Week",
                              },
                              {
                                  type: "month",
                                  count: 1,
                                  text: "1m",
                                  title: "View 1 month",
                              },
                              {
                                  type: "ytd",
                                  text: "YTD",
                                  title: "View year to date",
                              },
                              {
                                  type: "year",
                                  count: 1,
                                  text: "1y",
                                  title: "View 1 year",
                              },
                              {
                                  type: "all",
                                  text: "All",
                                  title: "View all",
                              },
                          ],
                      },
                      credits: {
                          enabled: false,
                      },
                  }
                : {};
        },
    },
    data() {
        return {};
    },
};
</script>
